/**
 * Formatting for the money inputs on both payments cards.
 *
 * A stored zero renders as an EMPTY input with a `0` placeholder, not a literal `"0"`. Most fees
 * and rates on a customer are zero, so rendering them as values fills the form with digits that
 * carry no information and have to be selected and deleted before anything can be typed. An
 * empty box with a `0` placeholder says the same thing and is immediately writable.
 *
 * The inverse is already handled: `toNumber` maps an empty string back to `0`, so an untouched
 * blank field saves as the zero it represents. The validators accept blank for the same reason —
 * without that, a customer whose fees are all zero would load a form that is invalid on arrival.
 */
export function toCentsInput(cents: number): string {
  if (cents === 0) {
    return ''
  }

  return String(cents)
}

/** Rates are `decimal(4,2)` on the backend, so a non-zero rate always shows both decimals. */
export function toRateInput(rate: number): string {
  if (rate === 0) {
    return ''
  }

  return rate.toFixed(2)
}
